import Icon from '../components/Icon.vue'

Icon.register({
  allergies: {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M416 112C398.4 112 384 126.4 384 144V216C384 220.4 380.4 224 376 224H360C355.6 224 352 220.4 352 216V64C352 46.4 337.6 32 320 32S288 46.4 288 64V216C288 220.4 284.4 224 280 224H264C259.6 224 256 220.4 256 216V32C256 14.4 241.6 0 224 0S192 14.4 192 32V216C192 220.4 188.4 224 184 224H168C163.6 224 160 220.4 160 216V64C160 46.4 145.6 32 128 32S96 46.4 96 64V305L72.4 272.5C59.4 254.6 34.4 250.7 16.5 263.7S-5.3 301.7 7.7 319.6L133.3 492.3C142.3 504.7 156.8 512.1 172.1 512.1H369.7C392 512.1 411.3 496.8 416.4 475.1L442.9 362.4C446.1 348.7 447.8 334.1 448 320.1V144C448 126.4 433.6 112 416 112zM176 416C167.2 416 160 408.8 160 400S167.2 384 176 384 192 391.2 192 400 184.8 416 176 416zM176 320C167.2 320 160 312.8 160 304S167.2 288 176 288 192 295.2 192 304 184.8 320 176 320zM240 448C231.2 448 224 440.8 224 432S231.2 416 240 416 256 423.2 256 432 248.8 448 240 448zM240 352C231.2 352 224 344.8 224 336S231.2 320 240 320 256 327.2 256 336 248.8 352 240 352zM304 384C295.2 384 288 376.8 288 368S295.2 352 304 352 320 359.2 320 368 312.8 384 304 384zM336 448C327.2 448 320 440.8 320 432S327.2 416 336 416 352 423.2 352 432 344.8 448 336 448zM368 320C359.2 320 352 312.8 352 304S359.2 288 368 288 384 295.2 384 304 376.8 320 368 320z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/allergies.js
// module id = fDdw
// module chunks = 144